/* eslint-disable @typescript-eslint/no-explicit-any */
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import ReactPaginate from 'react-paginate'
import { useTranslation } from 'react-i18next'

import { ListContainer } from '../../pages/styled'
import { HorseRank } from 'models'
import HorseNewRecord from '../HorseNewRecord'

const TopListRecord = ({
  data,
  handlePageClick,
  pageCount,
  pageCurrent,
  numberHorse
}: any) => {
  const { t } = useTranslation()
  console.log(handlePageClick, pageCount, pageCurrent, numberHorse)

  return (
    <ListContainer>
      <div className='my-horse-container'>
        <div className='d-flex header-horse text-uppercase'>
          <span className='name width-30 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.rankHorseName`)}</span>
          <span className='name width-3'></span>
          <span className='name width-3'></span>
          <span className='name width-3'></span>
          <span className='width-8 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.class`)}</span>
          <span className='width-8 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.field`)}</span>
          <span className='width-8 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.distance`)}</span>
          <span className='width-12 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.newRecordTime`)}</span>
          <span className='width-12 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.newRecordDate`)}</span>
          <span className='blood-line width-13 text_align_left'>{t(`${NOTIFICATION_MESSAGE}.owner`)}</span>
        </div>
        <table className='my-horse-table'>
          {data?.length === 0 ?
            (
              <span className='no_horse_record'>
                <span className='color-white font-size-24'>
                  No data found
                </span>
              </span>
            )
            : ""
          }
          
          {data?.length > 0 && (
            <tbody>
              {data?.map((horse: HorseRank, index: number) => {
                return (
                  <HorseNewRecord
                    key={index}
                    horse={horse}
                  />
                )
              })}
            </tbody>
          )}
        </table>
        {data?.length > 0 && parseInt(numberHorse) > 0 && (
          <div className='paginate'>
            <ReactPaginate
              nextLabel='>'
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel='<'
              pageClassName='page-item'
              pageLinkClassName='page-link'
              previousClassName='page-item'
              previousLinkClassName='page-link'
              nextClassName='page-item'
              nextLinkClassName='page-link'
              breakLabel='...'
              breakClassName='page-item'
              breakLinkClassName='page-link'
              containerClassName='pagination'
              activeClassName='active'
              forcePage={pageCurrent ? +pageCurrent - 1 : 0}
            />
          </div>
        )}
      </div>
    </ListContainer>
  )
}

export default TopListRecord
